require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ignite-session-21-feb-2026.json") })
        }
      }, "path---ignite-session-21-feb-2026");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ignite-session-21-feb-2026!./.cache/json/ignite-session-21-feb-2026.json
// module id = 1083
// module chunks = 231608221292675